import React from "react";
import PropTypes from "prop-types";

/**
 * Ekranın sitede neyi etkilediğini gösteren bilgi şeridi.
 *
 * Panelde hangi alanın sitenin neresini değiştirdiği belli olmuyordu;
 * her ekranın başına bu şerit konarak "nerede görünür" ve "canlıda gör"
 * bağlantısı veriliyor.
 */
const SITE = "https://buhara.com";

export default function PageHint({ what, where, links = [], note }) {
  return (
    <div className="bh-hint">
      <div className="bh-hint-icon" aria-hidden="true">
        <i className="bx bx-info-circle" />
      </div>
      <div className="bh-hint-body">
        <p className="bh-hint-what">{what}</p>
        {where && <p className="bh-hint-where">{where}</p>}
        {note && <p className="bh-hint-note">{note}</p>}
        {links.length > 0 && (
          <div className="bh-hint-links">
            <span>Canlıda gör:</span>
            {links.map((l) => (
              <a key={l.path} href={SITE + l.path} target="_blank" rel="noreferrer">
                {l.label}
                <i className="bx bx-link-external" />
              </a>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}

PageHint.propTypes = {
  what: PropTypes.string.isRequired,   // bu ekran neyi yönetiyor
  where: PropTypes.string,             // sitede nerede görünüyor
  note: PropTypes.string,              // dikkat edilecek nokta
  links: PropTypes.array,              // [{label, path}]
};
